import React from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

const ApiIcon: React.FC<SvgIconProps> = (props) => {
    return (
        <SvgIcon {...props} viewBox="0 0 24 24">
            <path
                opacity="0.4"
                d="M17 15.7639V15.485C17 14.8373 17 14.5135 17.1493 14.2532C17.2987 13.993 17.5677 13.8482 18.1056 13.5585C19.3711 12.8771 20.0039 12.5364 20.4801 12.797C20.5021 12.8091 20.5237 12.8219 20.5447 12.8356C21 13.1313 21 13.85 21 15.2874V17L19.8944 17.5528C18.5972 18.2014 17.9485 18.5257 17.4743 18.2326C17 17.9395 17 17.2143 17 15.7639Z"
                fill="currentColor"
            />
            <path
                opacity="0.4"
                d="M6.85065 14.2532C6.7013 13.993 6.43234 13.8482 5.89443 13.5585C4.62889 12.8771 3.99612 12.5364 3.5199 12.797C3.49787 12.8091 3.47631 12.8219 3.45525 12.8356C3 13.1313 3 13.85 3 15.2874V16.5L4.01928 17.1371C5.29878 17.9367 5.93852 18.3366 6.4358 18.0958C6.46891 18.0798 6.50112 18.0619 6.53226 18.0423C7 17.7483 7 16.9938 7 15.485C7 14.8373 7 14.5135 6.85065 14.2532Z"
                fill="currentColor"
            />
            <path
                opacity="0.4"
                d="M12 6.00291C11.6965 6.00291 11.4197 5.85312 10.866 5.55355L8.5 4.27344L12 2L15.5 4.27344L13.134 5.55355C12.5803 5.85312 12.3035 6.00291 12 6.00291Z"
                fill="currentColor"
            />
            <path
                d="M10.8453 2.47782C11.4088 2.15927 11.6906 2 12 2C12.3094 2 12.5912 2.15927 13.1547 2.47782L19.8453 6.25983C20.4088 6.57838 20.6906 6.73766 20.8453 7C21 7.26234 21 7.58089 21 8.21799V15.782C21 16.4191 21 16.7377 20.8453 17C20.6906 17.2623 20.4088 17.4216 19.8453 17.7402L13.1547 21.5222C12.5912 21.8407 12.3094 22 12 22C11.6906 22 11.4088 21.8407 10.8453 21.5222L4.1547 17.7402C3.59117 17.4216 3.3094 17.2623 3.1547 17C3 16.7377 3 16.4191 3 15.782V8.21799C3 7.58089 3 7.26234 3.1547 7C3.3094 6.73766 3.59117 6.57838 4.1547 6.25983L10.8453 2.47782Z"
                stroke="#fff"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M15.5 4.27344L13.134 5.55355C12.5803 5.85312 12.3035 6.00291 12 6.00291C11.6965 6.00291 11.4197 5.85312 10.866 5.55355L8.5 4.27344"
                stroke="#fff"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M12 11.6154V22M12 11.6154L20.5 7M12 11.6154L3.5 7"
                stroke="#fff"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M3 12L5.89443 13.5585C6.43234 13.8482 6.7013 13.993 6.85065 14.2532C7 14.5135 7 14.8373 7 15.485V19"
                stroke="#fff"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M21 12L18.1056 13.5585C17.5677 13.8482 17.2987 13.993 17.1493 14.2532C17 14.5135 17 14.8373 17 15.485V19"
                stroke="#fff"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </SvgIcon>
    );
};

export default ApiIcon; 